// const RENTAL_TYPES = ['Ebikes', 'Cars', 'Kayaks'];

const RENTAL_TYPES = ['Ebikes'];
// const RENTAL_TYPES = ['Ebikes'];




export default RENTAL_TYPES;